<template>
  <employee-profile-view 
    :user-uid="user.user_uid"
    :employee-uid="employee.employee_uid"
    :person-uid="person.person_uid"
  >
    <template v-slot:divider>
      <v-icon>forward</v-icon>
    </template>
  </employee-profile-view>  
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeProfileView: () => import('@/components/employee/ProfileView'),
    },

    metaInfo () {
      return {
        title: 'My Profile',
      }
    },
    computed: {  
      ...mapState({ user: 'currentUser', employee: 'currentEmployee', person: 'currentPerson' }),
    },
    created () {
      this.$store.dispatch('getCurrentUser')
      this.$store.state.isMyProfile = true
    },
  }
</script>

<style>
  .ct-square:before{
    content:unset !important;
  }
</style>
